import { useLoadingControl } from "../../../../../appfw/loading/use-loading-control.tsx";
import { useCallback, useEffect, useState } from "react";
import { eventerConsoleApiClient, Member } from "../../../../api-client/EventerConsoleApiClient.ts";
import { List } from "@mui/material";
import MemberItem from "./MemberItem.tsx";

interface MemberListProps {
    readonly accountId: string;
    readonly canManageMembers: boolean;
}

export default function MembersList({ accountId, canManageMembers }: MemberListProps) {

    const loadingControl = useLoadingControl("members-" + accountId)

    const [members, setMembers] = useState<undefined | Member[]>(undefined)

    const refresh = useCallback(async (abortController?: AbortController) => {
        await loadingControl.withLoading(async () => {
            let fetchedMembers = await eventerConsoleApiClient.listMembers({ accountId: accountId }, { abortController: abortController })
            const members = [...fetchedMembers]
                .sort((a, b) => {
                    let aT = a.user.name || a.email || a.user.id
                    let bT = b.user.name || b.email || b.user.id
                    return aT.localeCompare(bT)
                })
            setMembers(members)
        })
    }, [accountId, setMembers])

    const removeMember = useCallback(async (memberId: string) => {
        await loadingControl.withLoading(async () => {
            await eventerConsoleApiClient.removeMember({ accountId: accountId, memberId: memberId })
            await refresh()
        })
    }, [accountId, refresh])

    useEffect(() => {
        const abortController = new AbortController()
        refresh(abortController)
        return () => {
            abortController.abort()
        }
    }, [])

    if (members == undefined) {
        return null
    }


    let remove: undefined | ((memberId: string) => Promise<void>)
    if (canManageMembers) {
        remove = removeMember
    }

    return (
        <List>
            {
                members.map(member => <MemberItem key={member.email} member={member} remove={remove} />)
            }
        </List>
    )
}